<template>
  <div>
    <div class="row">
      <div class="col-12">
        <card class="card-gis-filter">
          <el-collapse v-model="activeName" @change="handleCollapse">
            <el-collapse-item :title="titleFilter" name="1">
              <div class="row mt-3">
                <div class="col-12 col-sm-6 col-md-2">
                  <label for="">{{ $t('common_words.map_type') }}: </label>
                  <br />
                  <el-select
                    clearable
                    filterable
                    class="select-default mb-3 shadow-sm"
                    v-model="mapType"
                    :placeholder="`${$t('common_words.select2')}...`"
                  >
                    <el-option
                      class="select-default"
                      :label="$t('climate.heat')"
                      value="heat"
                    ></el-option>
                    <el-option
                      class="select-default"
                      :label="$t('climate.points')"
                      value="point"
                    ></el-option>
                  </el-select>
                </div>
                <div class="col-12 col-sm-6 col-md-4">
                  <label for=""
                    >{{ $t('common_words.date_range_selection') }}:
                  </label>
                  <el-date-picker
                    v-if="renderComponent"
                    class="shadow-sm"
                    :clearable="false"
                    v-model="rangeDate"
                    type="daterange"
                    :picker-options="pickerOptions"
                    range-separator="-"
                    :start-placeholder="$t('common_words.initial_date')"
                    :end-placeholder="$t('common_words.final_date')"
                  >
                  </el-date-picker>
                </div>
                <div class="col-12 col-sm-6 col-md-2">
                  <label for="">{{ $t('common_words.farm') }}: </label>
                  <br />
                  <el-select
                    clearable
                    filterable
                    class="select-default mb-3 shadow-sm"
                    v-model="farmSel"
                    :placeholder="`${$t('common_words.select2')}...`"
                  >
                    <el-option
                      class="select-default"
                      v-for="item in farms"
                      :key="item.id + item.name"
                      :label="item.name"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </div>
                <div class="col-12 col-sm-6 col-md-3">
                  <label for="">{{ $t('common_words.allotment') }}: </label>
                  <br />
                  <el-select
                    @change="selectAllFromSelect('lotSel', getLotbyFarm())"
                    clearable
                    collapse-tags
                    multiple
                    filterable
                    style="width: 100%"
                    class="select-default mb-3 shadow-sm"
                    v-model="lotSel"
                    :placeholder="`${$t('common_words.select2')}...`"
                  >
                    <el-option
                      class="select-default selected-all"
                      v-for="item in getLotbyFarm()"
                      :key="item.id + item.name"
                      :label="item.name"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </div>
              </div>
              <div class="row">
                <div class="col-12 col-sm-12 col-md-4">
                  <label for="">{{ $t('diseases.plague_or_disease') }}: </label>
                  <br />
                  <el-select
                    @change="selectAllFromSelect('diseaseSel', diseases)"
                    clearable
                    collapse-tags
                    multiple
                    filterable
                    style="width: 100%"
                    class="select-default mb-3 shadow-sm"
                    v-model="diseaseSel"
                    :placeholder="`${$t('common_words.select2')}...`"
                  >
                    <el-option
                      class="select-default selected-all"
                      v-for="item in diseases"
                      :key="item.id + item.name"
                      :label="item.name"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </div>
                <div class="col-2">
                  <div class="text-left">
                    <label style="color: white">button</label>
                    <br />
                    <button
                      class="btn btn-filter btn-wd btn-info custom-shadow-btn"
                      @click="handleFilterRange"
                    >
                      {{ $t('common_words.filter') }}
                    </button>
                  </div>
                </div>
              </div>
            </el-collapse-item>
          </el-collapse>
        </card>
        <div class="row" v-if="details">
          <div class="col-12 map-climate">
            <div
              ref="map"
              class="map"
              v-if="renderComponent"
              style="height: 800px"
            ></div>
            <div
              id="toolbarDiv"
              class="esri-component esri-widget"
              v-if="renderComponent"
            >
              <button
                id="distance"
                class="action-button esri-widget--button esri-interactive esri-icon-measure-line"
                style="margin-bottom: 10px"
                :title="$t('common_words.distance_measurement_tool')"
              ></button>
              <button
                id="area"
                class="action-button esri-widget--button esri-interactive esri-icon-measure-area"
                style="margin-bottom: 10px"
                :title="$t('common_words.area_measurement_tool')"
              ></button>
              <button
                id="clear"
                class="action-button esri-widget--button esri-interactive esri-icon-trash"
                style="margin-bottom: 10px"
                :title="$t('common_words.clear_measurement')"
              ></button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from 'moment';
import MixinPermissions from 'src/util/mixinPermissions';
import MixinDatePicker from 'src/util/mixinDatePicker';
import MixinArcgisMap from 'src/util/mixinArcgisMap';
import MixinForm from 'src/mixins/forms/mixin-form';
import mixinMasters from 'src/util/mixinMasters';
import { Axios } from 'src/class/Axios.js';
import MixinMenu from 'src/util/mixinMenu';

export default {
  computed: {
    titleFilter() {
      if (this.valueCollapse) {
        return this.valueCollapse.length === 1
          ? this.$i18n.t('uti.mixinFilter.hideFilters')
          : this.$i18n.t('uti.mixinFilter.showFilters');
      }

      return this.$i18n.t('uti.mixinFilter.hideFilters');
    },
  },

  data() {
    return {
      center: {
        lat: 37.774546,
        lng: -122.433523,
      },
      activeName: '1',
      farms: [],
      farmSel: [],
      diseaseSel: [],
      lotSel: [],
      valueCollapse: null,
      mapData: {},
      kmlLayer: null,
      map: null,
      renderComponent: true,
      mapType: 'heat',
      diseases: [],
      details: false,
    };
  },

  mixins: [
    MixinPermissions,
    MixinDatePicker,
    MixinArcgisMap,
    mixinMasters,
    MixinForm,
    MixinMenu,
  ],
  watch: {
    '$i18n.locale': ['forceRerender', 'getSelectAll'],
  },

  methods: {
    getSelectAll() {
      this.diseases = this.concatAll(this.diseases.splice(1));
    },
    getLotbyFarm() {
      let resp = [];
      for (let index = 0; index < this.farms.length; index++) {
        const element = this.farms[index];
        if (element.id != 0 && this.farmSel == element.id) {
          element.lots.forEach((item) => {
            resp.push({
              id: item.id,
              name: 'Finca ' + element.name + ' - ' + item.name,
            });
          });
        }
      }

      return this.concatAll(resp);
    },

    handleFilterRange() {
      this.details = false;
      this.getGisData();
    },

    getGisData() {
      this.showHideLoading(true);
      let data = {
        route: 'diseases/diseasesampledetails/filter',
        datei: moment(this.rangeDate[0]).format('YYYY-MM-DD'),
        datef: moment(this.rangeDate[1]).format('YYYY-MM-DD'),
        farm: this.farmSel,
        lot: this.lotSel,
        disease: this.diseaseSel,
        map: this.mapType,
      };
      Axios.postMasters(data)
        .then((response) => {
          this.mapData = response.data.heatmap;
          this.details = true;

          if (
            response.data.center &&
            Object.keys(response.data.center).length > 0
          ) {
            this.center = response.data.center;
          }

          this.geoHeatMap();
        })
        .catch((error) => {
          console.log(error);
          this.details = false;
          this.showHideLoading();
        });
    },

    handleCollapse(val) {
      this.valueCollapse = val;
    },

    geoHeatMap() {
      this.renderComponent = false;
      this.$nextTick(() => {
        this.renderComponent = true;

        setTimeout(() => {
          if (this.mapData.length == 0) {
            this.geolocate();
            if (this.mapType == 'heat') {
              document.getElementById('toolbarDiv').style =
                'top: 19%;right: 30px';
              this.loadHeatMap(null, null);
            } else if (this.mapType == 'point') {
              document.getElementById('toolbarDiv').style =
                'top: 12%;right: 30px';
              this.loadPointMap(null, null);
            }
          } else {
            if (this.mapType == 'heat') {
              document.getElementById('toolbarDiv').style =
                'top: 19%;right: 30px';
              this.loadHeatMap(this.farmSel, this.mapData);
            } else if (this.mapType == 'point') {
              document.getElementById('toolbarDiv').style =
                'top: 12%;right: 30px';
              this.loadPointMap(this.farmSel, this.mapData);
            }
          }

          this.showHideLoading();
        }, 10);
      });
    },

    geolocate: function () {
      navigator.geolocation.getCurrentPosition((position) => {
        this.center = {
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        };
      });
    },
  },

  created() {
    this.showHideLoading(true);
    Axios.getMasters('farms/farms/only').then((response) => {
      this.farms = response.data.data;

      if (this.farms.length > 0) {
        this.farmSel = this.farms[0].id;
      }

      Axios.getMasters('diseases/diseases/')
        .then((resp) => {
          this.diseases = this.concatAll(resp.data.data);
          this.showHideLoading();
          // this.getGisData();
        })
        .catch((error) => {
          this.showHideLoading();
        });
    });
  },

  mounted() {
    this.selectedItemOnMenu('gis');
  },

  destroyed() {
    this.deselectedItemOnMenu('gis');
  },
};
</script>
<style lang="scss">
.card-gis-filter .card-body {
  padding: 15px 15px 10px 15px !important;
}

.card-gis-filter > .el-popper[x-placement^='bottom'] {
  margin-top: 38px !important;
}

.card-gis-filter div.el-collapse-item__header {
  padding-left: 10px !important;
}

.card-gis-filter {
  margin-bottom: 0px !important;
}
</style>
